import { API_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT, API_BURN_SUPERVISOR, API_BUSINESS_AS_USUAL_FOR_FEEDSTOCK, API_ENTITY_DETAILS, API_FEEDSTOCK_SOURCE, API_PROJECT_DESCRIPTION, API_PROJECT_STAKEHOLDERS } from '../constants/01-general-info';
import { GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL, GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS, GET_BURN_SUPERVISOR_FAIL, GET_BURN_SUPERVISOR_SUCCESS, GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL, GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS, GET_ENTITY_DETAILS_FAIL, GET_ENTITY_DETAILS_SUCCESS, GET_FEEDSTOCK_SOURCE_FAIL, GET_FEEDSTOCK_SOURCE_SUCCESS, GET_PROJECT_DESCRIPTION_FAIL, GET_PROJECT_DESCRIPTION_SUCCESS, GET_PROJECT_STAKEHOLDERS_FAIL, GET_PROJECT_STAKEHOLDERS_SUCCESS, POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL, POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS, POST_BURN_SUPERVISOR_FAIL, POST_BURN_SUPERVISOR_SUCCESS, POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL, POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS, POST_ENTITY_DETAILS_FAIL, POST_ENTITY_DETAILS_SUCCESS, POST_FEEDSTOCK_SOURCE_FAIL, POST_FEEDSTOCK_SOURCE_SUCCESS, POST_PROJECT_DESCRIPTION_FAIL, POST_PROJECT_DESCRIPTION_SUCCESS, POST_PROJECT_STAKEHOLDERS_FAIL, POST_PROJECT_STAKEHOLDERS_SUCCESS, START_LOADING } from '../types/01-general-info';
import { setAlert } from '../../alert';
import api from '../../../util/api';

const config = {
    headers: {
        'Content-Type': 'application/json'
    }
}

const formDataConfig = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}

export const getProjectDescription = (projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_PROJECT_DESCRIPTION + `/${projectId}`,
            config
        )
        dispatch({
            type: GET_PROJECT_DESCRIPTION_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: GET_PROJECT_DESCRIPTION_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postProjectDescription = (formData, projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_PROJECT_DESCRIPTION + `/${projectId}`,
            formData,
            config
        )
        dispatch({
            type: POST_PROJECT_DESCRIPTION_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: POST_PROJECT_DESCRIPTION_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getBusinessAsUsualForFeedstock = (projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_BUSINESS_AS_USUAL_FOR_FEEDSTOCK + `/${projectId}`,
            formDataConfig
        )
        dispatch({
            type: GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postBusinessAsUsualForFeedstock = (formData, projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_BUSINESS_AS_USUAL_FOR_FEEDSTOCK + `/${projectId}`,
            formData,
            formDataConfig
        )
        dispatch({
            type: POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getBiocharAndWaterSupplyEquipment = (projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT + `/${projectId}`,
            config
        )
        dispatch({
            type: GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postBiocharAndWaterSupplyEquipment = (formData, projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT + `/${projectId}`,
            formData,
            config
        )
        dispatch({
            type: POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getFeedstockSource = (projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_FEEDSTOCK_SOURCE + `/${projectId}`,
            config
        )
        dispatch({
            type: GET_FEEDSTOCK_SOURCE_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: GET_FEEDSTOCK_SOURCE_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postFeedstockSource = (formData, projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_FEEDSTOCK_SOURCE + `/${projectId}`,
            formData,
            config
        )
        dispatch({
            type: POST_FEEDSTOCK_SOURCE_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: POST_FEEDSTOCK_SOURCE_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getBurnSupervisor = (projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_BURN_SUPERVISOR + `/${projectId}`,
            config
        )
        dispatch({
            type: GET_BURN_SUPERVISOR_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: GET_BURN_SUPERVISOR_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postBurnSupervisor = (formData, projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_BURN_SUPERVISOR + `/${projectId}`,
            formData,
            config
        )
        dispatch({
            type: POST_BURN_SUPERVISOR_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: POST_BURN_SUPERVISOR_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getProjectStakeholders = (projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_PROJECT_STAKEHOLDERS + `/${projectId}`,
            formDataConfig
        )
        dispatch({
            type: GET_PROJECT_STAKEHOLDERS_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: GET_PROJECT_STAKEHOLDERS_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postProjectStakeholders = (formData, projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_PROJECT_STAKEHOLDERS + `/${projectId}`,
            formData,
            formDataConfig
        )
        dispatch({
            type: POST_PROJECT_STAKEHOLDERS_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: POST_PROJECT_STAKEHOLDERS_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getEntityDetails = (projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_ENTITY_DETAILS + `/${projectId}`,
            formDataConfig
        )
        dispatch({
            type: GET_ENTITY_DETAILS_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: GET_ENTITY_DETAILS_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postEntityDetails = (formData, projectId) => async dispatch => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_ENTITY_DETAILS + `/${projectId}`,
            formData,
            formDataConfig
        )
        dispatch({
            type: POST_ENTITY_DETAILS_SUCCESS,
            payload: data
        })
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'))
        dispatch({
            type: POST_ENTITY_DETAILS_FAIL,
            payload: error.response.data.detail
        })
    }
}

